export default __webpack_public_path__ + "static/media/multifamily.4ca59ec0.png";